__turbopack_context__.v({
  "miniToolbar": "EditorShareView-module__AcmnbW__miniToolbar",
  "talkBubble": "EditorShareView-module__AcmnbW__talkBubble",
});
